import React, { useEffect } from "react";

const AppFooter = (props) => {
  useEffect(() => {
    document.body.classList.add("footer");
    document.body.classList.remove("dashboard-container");


    return () => {
        document.body.classList.add("dashboard-container");
        document.body.classList.remove("footer");
    };
}, []);

  return (
    <>
      <footer className="footer">
        <div className="copy-right text-center text-xl-start">
          <div className="container-xxl">© Copyright CloudOne.2025. All rights reserved.</div>
        </div>
      </footer>
    </>
  );
};

AppFooter.propTypes = {};

export default AppFooter;
